module.exports = __webpack_public_path__ + "img/doc1.e3e03a50.png";